import Head from "next/head";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { getStatesCities, GetStoreData } from "../../api.services.js/others";
import AddressAutocomplete from "../../src/components/storeSuggestion";
import axios from "axios";

export const getServerSideProps = async () => {
  try {
    const response = await getStatesCities({});
    const statesData = response?.data?.getStates || [];
    return {
      props: { statesData },
    };
  } catch (error) {
    return {
      props: { statesData: [], error: error.message || "Error fetching data" },
    };
  }
};

const stores = [
  {
    title: "Signature Company Showrooms - Chennai",
    address:
      "2nd floor New No.85, Old No.30, Maharaja Tower, Land Mark Ashok Pillar First Avenue , Ashok Nagar, Chennai, Tamil Nadu, 600083",
    contact: "Vishnu Kr",
    phone: "9962511617",
    email: "vishnu.kr@orientbell.com",
    latitude: 13.033595,
    longitude: 80.212185,
  },
  {
    title: "Signature Company Showrooms - Dehradun",
    address:
      "Duggal Complax Nr. Kamla Place Hotel GMS Road, Dehradun, Uttarakhand, 248001",
    contact: "Yashasvi Mijrawat",
    phone: "7428594144",
    email: "yashasvi.mijrawat@orientbell.com",
    latitude: 30.308588,
    longitude: 78.007184,
  },
  // TODO : Removed by client on 31-03-2025
  // {
  //   title: "Signature Company Showrooms - Delhi",
  //   address: "M 47, M Block market GK – II Delhi – 48, 110048 Near Canara Bank",
  //   contact: "Nikhil Kumar Gautam",
  //   phone: "8373914460",
  //   latitude: 28.533589,
  //   longitude: 77.242506,
  // },
  {
    title: "Signature Company Showrooms - Kochi",
    address:
      "Surya Gayatri Building No. 32/8, B3 Puthiya Road, New Junction Opp. Holiday Inn Hotal Ernakulam bypass road, Cochin, Kerala, 682031",
    contact: "Raja Lakshmi",
    phone: "9745768058",
    email: "raja.lakshmi@orientbell.com",
    latitude: 9.992292,
    longitude: 76.315264,
  },
  {
    title: "Signature Company Showrooms - Lucknow",
    address:
      "Orient Bell Tile BoutiqueRajrani Apartment G-1 H. No. 970/71 Sector- B Near Beej Nigam office Badshah Nagar Railway Station Faizabad Road MahanagarLucknowUttar Pradesh9984200500",
    contact: "Chinmoy Ghosh",
    phone: "9984786404",
    email: "chinmoy.ghosh@orientbell.com",
    latitude: 26.8711,
    longitude: 80.964213,
  },
  {
    title: "Signature Company Showrooms - Pune",
    address:
      "Shop No 3 and 4 , A tower vega centre , C.T.S. No. 71o, Final Plot No . 401/1, shankarsheth road, Gultekdi, Pune, Maharashtra, 411037",
    contact: "Arbindo Ghosh",
    phone: "7391072247",
    email: "arbindo.ghosh@orientbell.com",
    latitude: 18.49984,
    longitude: 73.862651,
  },
  {
    title: "Signature Company Showrooms - Vadodara",
    address:
      "78-79, 2nd Floor, Surya Kiran Complex, Beside Banker Heart Institute, Old Padra Road, Vadodara, Gujarat 390007",
    contact: "Tapan Thaker",
    phone: "9727740342",
    email: "tapan.thaker@orientbell.com",
    latitude: 22.292511,
    longitude: 73.164375,
  },
];

function Index({ statesData, error }) {
  const router = useRouter();

  const [activeTabTop, setActiveTabTop] = useState("simple-search");
  const [selectedState, setSelectedState] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [cityFromSimpleSearch, setCityFromSimpleSearch] = useState("");
  const [allStores, setAllStores] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
  });

  const handleAdvancedSearch = (e) => {
    e.preventDefault();
    if (!selectedState.trim()) return;

    let formattedState = selectedState.toLowerCase().replace(/\s+/g, "-");
    let formattedCity = selectedCity.trim()
      ? selectedCity.toLowerCase().replace(/\s+/g, "-")
      : "";

    if (selectedCity.trim()) {
      router.push(`/store-locator/${formattedState}/${formattedCity}`);
    } else {
      router.push(`/store-locator/${formattedState}`);
    }
  };

  const handleStateChange = (event) => {
    const selectedStateValue = event.target.value;
    setSelectedState(selectedStateValue);
    const stateData = statesData.find(
      (item) => item.state === selectedStateValue
    );
    setCityOptions(stateData ? stateData.cities : []);
  };

  const handleCityChange = (event) => {
    setSelectedCity(event.target.value);
  };

  const sendSms = async () => {
    if (!modalIsOpen) {
      return;
    }
    if (!formData.name) {
      setFormData({
        ...formData,
        error: "Name number is mandatory",
      });
      return;
    }
    if (!formData.phone) {
      setFormData({
        ...formData,
        error: "Phone number is mandatory",
      });
      return;
    }
    if (!formData.city) {
      setFormData({
        ...formData,
        error: "City number is mandatory",
      });
      return;
    }
    if (formData.phone.length != 10) {
      setFormData({
        ...formData,
        error: "Please enter valid 10 digit mobile number",
      });
      return;
    }
    // setFullpageLoading(true);
    let d1 = modalIsOpen.title;
    let d2 = formData.name;
    let d3 = formData.city;
    let d4 = formData.phone;
    let d5 = formData.message;
    let U1 = formData.name;
    let U2 = modalIsOpen.title;
    let U3 = modalIsOpen.address;
    let U4 = modalIsOpen.phone;

    let obj = {
      d1,
      d2,
      d3,
      d4,
      d5,
      U1,
      U2,
      U3,
      U4,
      userPhone: formData.phone,
      dealerPhone: modalIsOpen.d_phone_no,
    };

    const res = await axios.post(
      "https://proxy.orientbell.com/send-storelocator-sms",
      obj
    );
    if (res.status == 200) {
      // setFullpageLoading(false);
      setModalIsOpen(false);
      setFormData({});
      swal(
        `Thank you for your interest in our tiles. We have shared the requested store's details on your WhatsApp`
      );
    } else {
      // setFullpageLoading(false);
      setModalIsOpen(false);
      setFormData({});
      swal(
        "We are unable to send address on your mobile, please try again after some time"
      );
    }
  };
  const redirectToGoogleMaps = (lat, lng) => {
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    window.open(googleMapsUrl, "_blank");
  };

  return (
    <>
      <Head>
        <meta
          name="description"
          content="With 2000+ tiles stores nationwide, Locate Orientbell Tiles Store or tile shop near you. Discover premium floor tiles and Wide range of designs for walls and bathrooms. Visit our store for expert advice and great deals!"
        ></meta>
        <title>
          Locate Tiles Store Dealer or Tile Shop Near Me | Orientbell Tiles
        </title>
        <meta
          name="title"
          content="Locate Tiles Store Dealer or Tile Shop Near Me | Orientbell Tiles"
        ></meta>
      </Head>
      <div className="obl-store-page">
        <div className="obl-store-intro-section">
          <div className="container">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="/store-locator">
                Store Locator
              </Breadcrumb.Item>
            </Breadcrumb>
            <div className="obl-store-intro-row">
              <div className="obl-store-intro-left">
                <h1>Orientbell Tiles Dealers</h1>
                <div className="store-search-section-inner">
                  <p>Locate The Nearest Tiles Stores</p>
                  <div className="obl-store-tab-section">
                    <div className="storetabs-menu">
                      <a
                        className={
                          activeTabTop === "simple-search"
                            ? "tab-item active"
                            : "tab-item"
                        }
                        onClick={() => setActiveTabTop("simple-search")}
                      >
                        {" "}
                        Search City{" "}
                      </a>
                      <a
                        className={
                          activeTabTop === "advanced-search"
                            ? "tab-item active"
                            : "tab-item"
                        }
                        onClick={() => setActiveTabTop("advanced-search")}
                      >
                        Advanced Search
                      </a>
                    </div>
                    <div className="obl-store-tab-data">
                      {/* Simple Search */}
                      <div
                        className={
                          activeTabTop === "simple-search"
                            ? "tab-data-col search-nearme active"
                            : "tab-data-col search-nearme"
                        }
                      >
                        <AddressAutocomplete />
                      </div>

                      {/* Advanced Search */}
                      <div
                        className={
                          activeTabTop === "advanced-search"
                            ? "tab-data-col search-location active"
                            : "tab-data-col search-location"
                        }
                      >
                        <form onSubmit={handleAdvancedSearch}>
                          <ul className="list-unstyled search-location">
                            <li className="input-group">
                              <label htmlFor="OutletState">
                                State<sup>*</sup>
                              </label>
                              <select
                                name="state"
                                className="input"
                                required
                                id="OutletState"
                                value={selectedState}
                                onChange={handleStateChange}
                              >
                                <option value="">Select a state</option>
                                {statesData.map((state) => (
                                  <option key={state.state} value={state.state}>
                                    {state.state}
                                  </option>
                                ))}
                              </select>
                            </li>
                            <li className="input-group">
                              <label htmlFor="OutletCity">City</label>
                              <select
                                name="city"
                                className="input"
                                id="OutletCity"
                                disabled={!selectedState}
                                value={selectedCity}
                                onChange={handleCityChange}
                              >
                                <option value="">Select a city</option>
                                {cityOptions.map((city) => (
                                  <option key={city} value={city}>
                                    {city}
                                  </option>
                                ))}
                              </select>
                            </li>
                            <li className="actions">
                              <div className="obl-store-actions-btn">
                                <button type="submit">
                                  <img
                                    src="/search-mobile-icon1.svg"
                                    alt="Search"
                                  />{" "}
                                  Search
                                </button>
                              </div>
                            </li>
                          </ul>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="obl-store-intro-right">
                <a href="#">
                  <img
                    src="/OBL-Sun-Proof-Your-Home-1200x400.avif"
                    alt="Dealers Banner"
                  />
                </a>
              </div>
            </div>

            {/* COCO / Signature stores  */}
            <div className="store_locator_row signature-store">
              {stores.map((store, index) => (
                <div className="obl_store_locator_col" key={index}>
                  <h3>{store.title}</h3>
                  <div className="store_add_row">
                    <div className="store_add_text">
                      <p>{store.address}</p>
                      <p>
                        <strong>Contact Person : {store.contact}</strong>
                      </p>
                      <p>
                        <strong>Phone : {store.phone}</strong>
                      </p>
                      {store.email && (
                        <p>
                          <a href={`mailto:${store.email}`}>{store.email}</a>
                        </p>
                      )}
                    </div>
                    <div className="store_add_icon">
                      <div className="store-whatsapp-icon">
                        <span onClick={() => setModalIsOpen(store)}>
                          <svg
                            stroke="green"
                            fill="green"
                            stroke-width="0"
                            viewBox="0 0 448 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path>
                          </svg>
                        </span>
                      </div>
                      <div
                        className="store-duration-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          redirectToGoogleMaps(store.latitude, store.longitude)
                        }
                      >
                        <img
                          src="/duration.svg"
                          alt="Duration Icon"
                          data-clarity-loaded="1j41qhv"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={modalIsOpen}
        className="pincode-popup-bx"
        onHide={() => setModalIsOpen(false)}
      >
        <Modal.Dialog>
          <Modal.Header closeButton>
            <Modal.Title>Send this address on WhatsApp to me</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                sendSms();
              }}
            >
              <label>Name*</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    name: e.target.value,
                    error: "",
                  });
                }}
              />
              <label>Mobile Number*</label>
              <input
                type="number"
                value={formData.phone}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    phone: e.target.value,
                    error: "",
                  });
                }}
              />
              <label>City*</label>
              <input
                type="text"
                value={formData.city}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    city: e.target.value,
                    error: "",
                  });
                }}
              />
              <label>Message</label>
              <input
                type="text"
                value={formData.message}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    message: e.target.value,
                    error: "",
                  });
                }}
              />
              {formData?.error ? (
                <p className="error text-danger">{formData?.error}</p>
              ) : (
                <p></p>
              )}
              <Button
                variant="primary"
                type="submit"
                onClick={sendSms}
                style={{ width: "100%" }}
              >
                Submit
              </Button>
            </form>
          </Modal.Body>
        </Modal.Dialog>
      </Modal>
    </>
  );
}

export default Index;
